<template>
    <div class="row g-0 app-auth-wrapper">
        <router-view />
        <Footer />
    </div>
    <Loader v-show="loading" />
</template>

<script>
import Footer from '@/components/Footer.vue';
import Loader from "@/components/Loader.vue";
import { emitter } from '@/services/emitter.service';

export default {
    components: {
        Footer,
        Loader
    },
    data() {
        return { loading: false };
    },
    created() {
        emitter.on("showLoader", (e) => {
            this.loading = e;
        });
    }
}
</script>